import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import find from 'lodash/find';
import { map, tap } from 'rxjs/operators';
import { SubmissionService } from '../../../../core/services/management/submission/submission.service';
import { RolesService } from '../../../../core/services/roles/roles.service';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';
import { Submission, ChangeLog, SubmissionApproval } from '../../../../shared/models/flow-manager-core';
import { select, Store } from "@ngrx/store";
import { selectSingleApprover } from "../../../state/selectors/entity-config.selector";

@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.scss']
})
export class ApprovalsComponent implements OnInit {

  approvalsSelected = 'APPROVED';
  productionReadyCount = 0;
  myApprovalsCount = 0;
  approvals = {};
  submissionsList: Observable<Submission[]>;
  allSubmissionsList: Observable<Submission[]>;
  submissions: Submission;
  changeLog: Observable<ChangeLog[]>;
  submissionApproval: Observable<SubmissionApproval>;
  searchForApprovalsValue: String = '';
  entityList: any = [];
  isSingleApproverObs: Observable<boolean>;

  constructor(
    private submissionService: SubmissionService,
    public rolesService: RolesService,
    private sharedService: SharedService,
    private store: Store<any>
  ) { }

  ngOnInit() {
    this.sharedService.setHasNotifications = false;
    this.submissionService.getSubmissionsBySubmissionState('APPROVED').subscribe((x) => {
      this.productionReadyCount = x.length || 0;
    });
    // User is a approver
    if (this.rolesService.isReviewer()) {
      this.approvalsSelected = 'MY_APPROVALS';
      this.allSubmissionsList = this.submissionsList = this.submissionService.getMyApprovals().pipe(
        map((x) => {
          this.myApprovalsCount = x.length || 0;
          return x;
        })
      );
    } else {
      this.approvalTypeChange('APPROVED');
    }
    this.entityList = this.sharedService.getEntityList;
    this.isSingleApproverObs = this.store.select(selectSingleApprover).pipe(
      tap(isSingleApprover => {
        if (!isSingleApprover) {
          this.approvalTypeChange('DEPLOYED');
          this.approvalsSelected = 'DEPLOYED';
        }
      })
    );
  }

  approvalTypeChange(SubmissionState: string) {
    this.submissions = null;
    if (SubmissionState === 'MY_APPROVALS') {
      this.allSubmissionsList = this.submissionsList = this.submissionService.getMyApprovals().pipe(
        map((x) => {
          this.myApprovalsCount = x.length || 0;
          return this.filterApprovals(x);
        })
      );
    } else {
      this.allSubmissionsList = this.submissionsList = this.submissionService
        .getSubmissionsBySubmissionState(SubmissionState)
        .pipe(
          map((x) => {
            if (SubmissionState === 'APPROVED') {
              this.productionReadyCount = x.length || 0;
            }
            return this.filterApprovals(x);
          })
        );
    }

    this.searchForApprovalsHandler(this.searchForApprovalsValue);
  }

  selectedApproval(submission: Submission) {
    if (submission && submission.id) {
      this.submissions = submission;
      this.changeLog = this.submissionService.getChangeLog('dev', submission.id.toString());
      this.submissionApproval = this.submissionService.getSubmissionApprovals(
        submission.id.toString()
      );
    }
  }

  resetSubmissions(value: number) {
    this.approvalTypeChange(this.approvalsSelected);
  }

  searchForApprovals(event: any) {
    this.searchForApprovalsValue = event.value;
    this.searchForApprovalsHandler(event.value);
  }

  searchForApprovalsHandler(value: String) {
    if (!value || value === '') {
      this.submissionsList = this.allSubmissionsList;
      return;
    }

    this.submissionsList = Object.assign(of(), this.submissionsList).pipe(
      map((submission) => {
        return this.filterApprovals(submission);
      })
    );
  }

  filterApprovals(x) {
    return [].concat(x).filter((item) => {
      const client = find(this.entityList, (o) => {
        return (item.entityId ? o.key === item.entityId.toString() : '');
      });
      return (
        (item.flowPath &&
          item.flowPath.toLowerCase().indexOf(this.searchForApprovalsValue.toLowerCase()) !== -1) ||
        (client &&
          client.value.toLowerCase().indexOf(this.searchForApprovalsValue.toLowerCase()) !== -1)
      );
    });
  }
}

function sortByDate(a, b) {
  const dateA: Date = new Date(a.cdcUpdateTimestamp);
  const dateB: Date = new Date(b.cdcUpdateTimestamp);

  if (dateA.getTime() < dateB.getTime()) {
    return 1;
  }
  if (dateA.getTime() > dateB.getTime()) {
    return -1;
  }

  // Date must be equal
  return 0;
}

function convertDate(date): string {
  return new Date(date).toLocaleString().replace(',', '');
}

const onNext = (myApprovals, approvedSubmissions, parent) => {
  parent.selectedSubmission = approvedSubmissions.filter((approval) => {
    return !myApprovals.includes(approval.submission.id);
  });

  parent.myApprovalsCount = parent.selectedSubmission.length;
};
const onError = (parent) => {
  parent.emptyRecord = true;
  parent.loadingIcon = false;
};
const onComplete = (parent) => {
  parent.loadingIcon = false;
};

